import { useCallback } from "react";
import { useTranslation } from "react-i18next";

interface UseOpenChangeWithConfirmationProps {
  isDirty: boolean;
  setOpen?: (open: boolean) => void;
}

export const useOpenChangeWithConfirmation = ({
  isDirty,
  setOpen,
}: UseOpenChangeWithConfirmationProps) => {
  const { t } = useTranslation();
  const confirmationMessage = t("unsaved_changes");

  return useCallback(
    (open: boolean) => {
      if (!open && isDirty) {
        const confirmed = window.confirm(confirmationMessage);
        if (!confirmed) {
          return false;
        }
      }
      setOpen?.(open);
      return true;
    },
    [isDirty, confirmationMessage, setOpen],
  );
};
